<template>
  <div style="background: linear-gradient(112.14deg, #3a7bd5 100%, #00d2ff 0%)">
    <div class="container">
      <div
        class="d-flex flex-column justify-content-center"
        style="min-height: 100vh; max-height: 100vh"
      >
        <div class="row p-0 w-100 m-0">
          <div class="col-md-8 d-none d-md-block">
            <div class="ms-6 text-white">
              <p class="fs-6 mb-0">Selamat datang di</p>
              <p class="fs-3 fw-bold mb-3">
                AISnet Web Institut Teknologi Garut
              </p>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div
              class="mb-7 d-flex align-items-center justify-content-md-center justify-content-between"
            >
              <img src="@/assets/logo.png" class="h-40px" />
              <button
                class="btn d-block text-light d-md-none p-0"
                data-bs-toggle="modal"
                data-bs-target="#modalLayanan"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.3"
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="10"
                    fill="currentColor"
                  />
                  <rect
                    x="11"
                    y="14"
                    width="7"
                    height="2"
                    rx="1"
                    transform="rotate(-90 11 14)"
                    fill="currentColor"
                  />
                  <rect
                    x="11"
                    y="17"
                    width="2"
                    height="2"
                    rx="1"
                    transform="rotate(-90 11 17)"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="row p-0 w-100 m-0">
          <div class="col-md-8 d-none d-md-block">
            <div class="rounded bg-white border border-secondary px-6 py-5">
              <info-layanan />
              <div class="mt-4">
                <p class="mb-1">Unduh Aplikasi AISnet</p>
                <div class="d-flex gap-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetforstudent&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-primary"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Student
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetlecturer&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-success"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Lecturer
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetparents&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-danger"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Parent
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <form class="w-100" @submit.prevent="proccessLogin">
              <div class="fv-row mb-7">
                <label class="form-label fs-6 text-white fw-normal"
                  >Username</label
                >
                <div class="position-relative">
                  <div class="position-absolute translate-middle-y top-50 ms-3">
                    <span class="svg-icon svg-icon-2hx">
                      <icon-guard-user />
                    </span>
                  </div>

                  <input
                    class="form-control form-control-lg fw-normal ps-15 border-0 rounded-2"
                    type="text"
                    v-model="form.email"
                    placeholder="Masukan username anda disini"
                    autofocus
                  />
                </div>
              </div>

              <div class="fv-row mb-10 mb-md-15">
                <label class="form-label fs-6 text-white fw-normal"
                  >Password</label
                >
                <div class="position-relative">
                  <div class="position-absolute translate-middle-y top-50 ms-3">
                    <span class="svg-icon svg-icon-2hx">
                      <icon-guard-password />
                    </span>
                  </div>

                  <input
                    class="form-control form-control-lg fw-normal ps-15 border-0 rounded-2"
                    type="password"
                    v-model="form.password"
                    placeholder="Masukan password anda disini"
                  />
                </div>
              </div>

              <button
                class="btn btn-primary w-100 mb-5"
                type="submit"
                :disabled="loading"
              >
                <div v-if="loading">
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Tunggu Sebentar
                </div>
                <div v-else>Masuk</div>
              </button>

              <button
                @click="loginWithGoogle"
                class="btn btn-icon-dark btn-text-dark btn-secondary w-100 d-none"
                type="button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="24"
                  height="24"
                  viewBox="0 0 48 48"
                >
                  <path
                    fill="#fbc02d"
                    d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                  ></path>
                  <path
                    fill="#e53935"
                    d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                  ></path>
                  <path
                    fill="#4caf50"
                    d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                  ></path>
                  <path
                    fill="#1565c0"
                    d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                  ></path>
                </svg>
                Masuk dengan Google
              </button>

              <div class="d-block d-md-none">
                <p class="fs-6 mt-15 mb-2 text-center text-white">
                  Atau unduh aplikasi AISnet
                </p>

                <div class="d-flex flex-column gap-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetforstudent&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-secondary w-100"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Student
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetlecturer&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-secondary w-100"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Lecturer
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.itg.aisnetparents&pcampaignid=web_share"
                    target="_blank"
                    class="btn btn-icon-dark btn-text-dark btn-secondary w-100"
                  >
                    <span class="svg-icon svg-icon-1">
                      <icon-logo-android />
                    </span>
                    AISnet for Parent
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- begin::modal -->
  <!-- begin::layanan -->
  <modal-fullscreen-sm id="modalLayanan" title="Layanan AISnet">
    <template #content>
      <info-layanan />
    </template>
  </modal-fullscreen-sm>
  <!-- end::layanan -->
  <!-- end::modal -->
</template>

<script>
import { setState } from "@/store";

// apis
import { authLogin, loginWithGoogle } from "@/apis/auth";
import { useRoute, useRouter } from "vue-router";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
    };
  },

  mounted() {
    this.handleGoogleCallback();
  },

  methods: {
    async proccessLogin() {
      this.loading = true;
      try {
        if (this.form.email.length == 0 || this.form.password.length == 0) {
          Swal.fire({
            icon: "error",
            text: "Username atau Password tidak boleh kosong",
            showConfirmButton: false,
            timer: 5000,
          });
        } else {
          const data = await authLogin(this.form);
          if (data.data.status == "success") {
            setState({
              accessToken: data.data.content.access_token,
            });

            setState({
              accessToken: data.data.content.access_token,
              user: {
                nama: "",
                email: "",
                nim: "",
                peran: data.data.content.peran,
                akses: data.data.content.akses,
                foto: "/img/blank.aad363d0.png",
              },
            });

            window.location.href = "/";
          }
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: "Username atau Password salah",
          showConfirmButton: false,
          timer: 5000,
        });
      }
      this.loading = false;
    },

    async loginWithGoogle() {
      try {
        const { data: response } = await loginWithGoogle();

        if (response?.url) window.location.href = response.url;
      } catch (error) {
        console.error("Gagal mendapatkan URL Google:", error);
      }
    },

    async handleGoogleCallback() {
      try {
        const route = useRoute();
        const router = useRouter();
        // 1. Ambil isi dari redirect
        const redirectParam = route.query.redirect; // misalnya "/?token=...%26role=..."

        // 2. Decode URL
        const decodedRedirect = decodeURIComponent(redirectParam);

        // 3. Gunakan URLSearchParams untuk parsing token dan role
        const queryFromRedirect = new URLSearchParams(
          decodedRedirect.split("?")[1]
        );

        const token = queryFromRedirect.get("token");
        const role = queryFromRedirect.get("role");
        const access = queryFromRedirect.get("access");

        if (token && role && access) {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: `Selamat datang di aplikasi AISnet`,
            showConfirmButton: false,
            timer: 2000,
          });

          setTimeout(() => {
            setState({
              accessToken: atob(token),
              user: {
                nama: "",
                email: "",
                nim: "",
                peran: atob(role),
                akses: atob(access),
                foto: "/img/blank.aad363d0.png",
              },
            });

            window.location.href = "/";
          }, 2000);
        } else if (queryFromRedirect.get("error")) {
          const newError = queryFromRedirect.get("error");
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: newError,
            showConfirmButton: false,
          });

          const url = new URL(window.location.href);
          url.searchParams.delete("redirect");
          window.history.replaceState({}, document.title, url);
        }
      } catch (error) {
        console.error("Gagal memproses login:", error);
      }
    },
  },
};
</script>
